<template>
    <div id="shedule" class="form-item radio">
        <div class="inline radio-header" valign="center" justify="between">
            <div class="radio-item">
                <input type="radio" id="shedule1" v-model="data.mode" value="mon_fri" />
                <label for="shedule1">Пн - Пт</label>
            </div>
            <div class="range" v-if="data.mode == 'mon_fri'">
                <TimeSelect :value.sync="data.mon_from"></TimeSelect>
                <span>&ndash;</span>
                <TimeSelect :value.sync="data.mon_to"></TimeSelect>
            </div>
        </div>
        <div class="inline radio-content" valign="center" justify="between" v-if="data.mode == 'mon_fri'">
            <p>Суббота</p>
            <div class="range">
                <TimeSelect :value.sync="data.st_from"></TimeSelect>
                <span>&ndash;</span>
                <TimeSelect :value.sync="data.st_to"></TimeSelect>
            </div>
        </div>
        <div class="inline radio-content" valign="center" justify="between" v-if="data.mode == 'mon_fri'">
            <p>Воскресенье</p>
            <div class="range">
                <TimeSelect :value.sync="data.sn_from"></TimeSelect>
                <span>&ndash;</span>
                <TimeSelect :value.sync="data.sn_to"></TimeSelect>
            </div>
        </div>

        <div class="radio-item radio-header">
            <input type="radio" id="shedule2" v-model="data.mode" value="24_7" />
            <label for="shedule2">24/7</label>
        </div>
        <div class="radio-item radio-header">
            <input type="radio" id="shedule3" v-model="data.mode" value="personal" />
            <label for="shedule3">Персональное</label>
        </div>
    </div>
</template>

<script>
    import TimeSelect from '@/components/TimeSelect.vue'
    export default {
        props: ['data'],
        components: {
            TimeSelect
        }
    }
</script>